module.exports = __webpack_public_path__ + "img/bk_05.636b2e0b.png";